import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';

// Importar la fuente
import '@/assets/fonts/logirent.css';

Vue.use(Vuetify);

export default new Vuetify({
  // Auditoría P1: textos de Vuetify en español (tablas, calendario, selectores de fecha)
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        primary: '#5D1C34',
        secondary: '#1B4982',
        accent: '#1A1E22',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  treeShake: true,
  defaultAssets: {
    font: {
      family: 'sans-serif'
    }
  },
  options: {
    customProperties: true
  }
});
